import { useState } from 'react';
import { Info } from 'lucide-react';
import {
  GlassModal,
  GlassModalContent,
  GlassModalHeader,
  GlassModalTitle,
  GlassModalDescription,
} from '@/components/common/GlassModal/GlassModal';
import type { GetDescriptionFn } from '@/types/sectionDescription';

interface SectionDescriptionTextProps {
  getDescription?: GetDescriptionFn;
  featureName?: string;
  sectionKey: string;
  className?: string;
}

export function SectionDescriptionText({
  getDescription,
  featureName,
  sectionKey,
}: SectionDescriptionTextProps) {
  const [open, setOpen] = useState(false);

  if (!getDescription || !featureName) return null;

  const desc = getDescription(featureName, sectionKey);
  if (!desc?.description) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center rounded-full p-0.5 text-muted-foreground hover:text-[var(--color-primary-start)] transition-colors cursor-pointer"
        aria-label="Info"
      >
        <Info className="h-4 w-4" />
      </button>
      <GlassModal open={open} onOpenChange={setOpen}>
        <GlassModalContent className="sm:max-w-md">
          <GlassModalHeader>
            <GlassModalTitle>{desc.title ?? featureName}</GlassModalTitle>
            <GlassModalDescription>{desc.description}</GlassModalDescription>
          </GlassModalHeader>
        </GlassModalContent>
      </GlassModal>
    </>
  );
}
